import { useTranslation } from "react-i18next";
import Millimetre from "../../../../../../components/Math/Units/Metric/Millimetre";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Knicklaenge({ kritischeKnicklaenge }) {
  const { t } = useTranslation("translation");
  const KnicklaengeFormula = `\\displaystyle L_{cr} =  \\beta \\cdot L`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.dinEN1993.verification.criticalBucklingLength")}</p>}
      formulaValue={
        <ToolTip id={"KnicklaengeFormula"} type={IconType.FORMULA} formula={KnicklaengeFormula} />
      }
      indicesValue={
        <span>
          L<sub>cr</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={kritischeKnicklaenge} decimalScale={0} />
        </span>
      }
      unitValue={<Millimetre />}
    />
  );
}

export default Knicklaenge;
